import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";

const toUiString = (
  value: Date | null | undefined,
  showDate = true,
  showTime = true
) => {
  if (!value || (!showDate && !showTime)) {
    return "";
  }

  const datePart = showDate ? format(value, "MM/dd/yyyy") : "";
  const timePart = showTime ? format(value, "hh:mm a") : "";
  return `${datePart} ${timePart}`.trim();
};

const toLocalUiString = (
  value: Date | null | undefined,
  showDate = true,
  showTime = true
) => {
  if (!value || (!showDate && !showTime)) {
    return "";
  }

  if (typeof value === "string") value = new Date(value);

  const localDate = utcToZonedTime(value, "America/Los_Angeles");
  return toUiString(localDate, showDate, showTime);
};

const parseHoursMinutes = (time: string) => {
  const [h, m] = time.split(":").map((x) => parseInt(x));
  const ms = new Date().setHours(h, m);
  return new Date(ms);
};

const toLocalUiStringHoursMinutes = (
  date: Date,
  locales?: Intl.LocalesArgument
) => {
  return date.toLocaleTimeString(locales, {
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const dateUtils = {
  toLocalUiString,
  parseHoursMinutes,
  toLocalUiStringHoursMinutes,
};
